
import FAQCard from '@/components/shared/FAQCard';
import MarketAnalysisFAQDialog from "@/components/marketAnalysis/MarketAnalysisFAQDialog";
import MarketAnalysisService from "@/service/MarketAnalysisService";
import subscriptionConstants from '@/constants/subscription.constants';

const { subscribeProductKeys } = subscriptionConstants;

export default {
    name: 'FAQList',

    components: {
        FAQCard,
        MarketAnalysisFAQDialog,
    },

    props: {
        maxQuestions: {
            type: Number,
            default: null
        },
    },

    emits: ['question-click'],

    data() {
        return {
            isLoading: false,
            questions: [],
            isFAQDialogVisible: false,
            selectedFaq: {},
        }
    },

    computed: {
        isLoggedIn() {
            return !!this.$store.state.account.user;
        },
        displayedQuestions() {
            if (this.maxQuestions) {
                return this.questions.slice(0, this.maxQuestions);
            }
            return this.questions;
        },
        isSubscribedFinAgent() {
            return this.isLoggedIn && this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
        isFreePlan() {
            return this.isLoggedIn && !this.isSubscribedFinAgent;
        },
        isReachFreePlanLimit() {
            return this.$store.state.finAgent.isReachFreePlanLimit;
        },
    },

    watch: {
        isLoggedIn: {
            handler() {
                this.fetchFAQ();
            },
        },
        isFAQDialogVisible(state) {
            if (!state) {
                this.selectedFaq = {}
            }
        },
    },

    created() {
        this.marketAnalysisService = new MarketAnalysisService(this.$axios);
        this.fetchFAQ();
    },

    beforeDestroy() {
        if (this.currentRequest) {
            this.currentRequest.cancel();
        }
    },

    methods: {
        openFAQDialog(question) {
            this.selectedFaq = question
            this.isFAQDialogVisible = true
        },
        async fetchFAQ() {
            try {
                this.isLoading = true;
                if (this.currentRequest) {
                    await this.currentRequest.cancel();
                }
                const axiosSource = this.$axios.CancelToken.source();
                this.currentRequest = { cancel: axiosSource.cancel };
                const lang = this.$getCurrentLocale();
                
                this.questions = await this.marketAnalysisService.getFAQ(axiosSource.token, lang);
                this.isLoading = false;
                
                // Apply color classes based on user count
                const userCountList = this.questions.map(question => question.relatedUserQuestionsCount).sort((a, b) => b - a);
                this.questions = this.questions.map(question => {
                    const index = userCountList.findIndex(e => e === question.relatedUserQuestionsCount);
                    return {...question, class: `question-color-${index > 9 ? 10 : index + 1}`};
                });
            } catch (err) {
                if (this.$axios.isCancel(err)) {
                    return;
                }
                this.questions = [];
                this.isLoading = false;
            }
        },

        handleLikeToggle({ id, isLiked }) {
            if (!this.isLoggedIn) {
                return;
            }
            if (isLiked) {
                this.dislikeFAQ(id);
            } else {
                this.likeFAQ(id);
            }
        },

        async likeFAQ(id) {
            this.questions = this.questions.map(question => {
                if (question.id === id) {
                    question.liked = true;
                    question.likes += 1;
                }
                return question;
            });
            await this.marketAnalysisService.likeFAQ(id);
        },

        async dislikeFAQ(id) {
            this.questions = this.questions.map(question => {
                if (question.id === id) {
                    question.liked = false;
                    question.likes -= 1;
                }
                return question;
            });
            await this.marketAnalysisService.dislikeFAQ(id);
        },

        // Public methods for parent components to use
        refetch() {
            this.fetchFAQ();
        },

        getQuestions() {
            return this.questions;
        }
    }
}
